import { Card, Skeleton } from "antd";

import React from "react";
import styled from "styled-components";

export const SkeletonLine = () => {
	return (
		<StyledCard style={{ margin: 10 }}>
			<Skeleton active paragraph={{ rows: 1, width: "100%" }}></Skeleton>
		</StyledCard>
	);
};

const StyledCard = styled(Card)`
	.ant-card-body {
		width: 360;
		padding: 0 16px;
	}
`;
